<template>
  <div>
    <div class="ui grid">
      <div class="sixteen wide column">
sadasdasd
      </div>
    </div>
  </div>
</template>

<script>
//import Booking from '../components/Booking.vue'
import * as services from '../../services'

export default {
  components: {
//    Booking
  },
  data() {
    return {

    }
  },
  beforeRouteEnter(to, from, next) {
    let reservationToken = to.params.id

    if (!reservationToken) next('/')

    services.reservationService.patch(null, {confirmed: true}, { query: { t: reservationToken, confirmed: false } }).then(reservations => {
      if (reservations.length === 0) next('/')

      // we do this to trigger patched event on bookings
      for (let reservation of reservations) {
        services.bookingService.patch(null, { _reservation: reservation._id }, { query: { _reservation: reservation._id }})
      }

      next({ path: '/', query: { confirmed: true, code: reservations[0].code }})
    }).catch(error => {
      next('/')
    })
  },
  mounted() {

  }
}
</script>



// WEBPACK FOOTER //
// ConfirmReservation.vue?7ac96b84